import { ObjectPool } from './ObjectPool.js';
import { Frames } from '../utils/atlas.js';

/**
 * All pooled gameplay sprites — used for caps and iteration.
 */
export class EntityPools {
  /** @param {Phaser.Scene} scene */
  constructor(scene) {
    const commonPre = 12;
    this.collectibles = new ObjectPool(scene, 'game-atlas', Frames.COLLECTIBLE, commonPre);
    this.wbc = new ObjectPool(scene, 'game-atlas', Frames.WBC, 10);
    this.antibodies = new ObjectPool(scene, 'game-atlas', Frames.ANTIBODY, 10);
    this.platelets = new ObjectPool(scene, 'game-atlas', Frames.PLATELET, 14);
    this.powerShield = new ObjectPool(scene, 'game-atlas', Frames.POWER_SHIELD, 3);
    this.powerSpeed = new ObjectPool(scene, 'game-atlas', Frames.POWER_SPEED, 3);
    this.powerInvis = new ObjectPool(scene, 'game-atlas', Frames.POWER_INVIS, 3);
    this.powerSlow = new ObjectPool(scene, 'game-atlas', Frames.POWER_SLOW, 3);
    this.particles = new ObjectPool(scene, 'game-atlas', Frames.PARTICLE, 24);

    /** @type {ObjectPool[]} */
    this.gamePools = [
      this.collectibles,
      this.wbc,
      this.antibodies,
      this.platelets,
      this.powerShield,
      this.powerSpeed,
      this.powerInvis,
      this.powerSlow,
    ];
  }

  totalGameplayActive() {
    return this.gamePools.reduce((s, p) => s + p.activeCount, 0);
  }

  totalParticles() {
    return this.particles.activeCount;
  }

  totalWithParticles() {
    return this.totalGameplayActive() + this.totalParticles();
  }

  /** @param {Phaser.GameObjects.Image} img */
  releaseAny(img) {
    for (const p of [...this.gamePools, this.particles]) {
      if (p.active.has(img)) {
        p.release(img);
        return true;
      }
    }
    return false;
  }
}
